import React from 'react'
import { makeStyles } from '@material-ui/styles'
import MuiTab, { TabProps as MuiTabProps } from '@material-ui/core/Tab'
import { mutualTheme } from '~/utils/theme'

const useStyles = makeStyles({
  tab: {
    fontSize: 16,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    textTransform: 'none',
    gap: mutualTheme.spacing(0.5),
    fontWeight: mutualTheme.typography.fontWeightRegular,
    [mutualTheme.breakpoints.down('md')]: {
      fontSize: 14
    }
  },
  tabSelected: {
    fontSize: 16,
    fontWeight: mutualTheme.typography.fontWeightBold,
    [mutualTheme.breakpoints.down('md')]: {
      fontSize: 14
    }
  }
})

export const Tab: React.FC<MuiTabProps> = (props) => {
  const classes = useStyles()
  return <MuiTab {...props} classes={{ root: classes.tab, selected: classes.tabSelected }} />
}
